import { useDispatch, useSelector } from 'react-redux'
import { DefaultReducerProps } from '../store/reducers'
import { IAppConfig } from '../types/appConfig'
import { setReduxAppConfig } from '../store/reducers/appConfig/actions'

export default function useAppConfig() {
  const dispatch = useDispatch()

  const appConfig = useSelector((state: DefaultReducerProps) => state.appConfig)

  function setAppConfig(c: IAppConfig) {
    dispatch(setReduxAppConfig(c))
  }

  return {
    appConfig,
    setAppConfig,
  }
}
